import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as MuiTooltip } from '@mui/material';
import { forwardRef } from 'react';
import { PreLineBox } from './Tooltip.styled';
const Tooltip = forwardRef(({ multiline, title, ...props }, ref) => {
    return _jsx(MuiTooltip, { ...props, ref: ref, title: multiline ? _jsx(PreLineBox, { children: title }) : title });
});
export { Tooltip };
